import { getTranslationOrInnerText, isHTMLElement } from 'whisper-base';
import { NudgeTypes } from '../../constants';
import { Definition as CoachingTipTooltipDefinition } from './coaching-tip-tooltip';
import { Definition as OnboardingDemoDefinition } from './onboarding-demo';
import { Definition as OnboardingTourDefinition } from './onboarding-tour';
import { Definition as CemCalloutDefinition } from '../managed/cem-callout';
import { createExclusionSelector } from '../../create-exclusion-selector';
export const Definition = {
  selector: createExclusionSelector(`[data-component-name="UIPopover"]`, [CoachingTipTooltipDefinition.selector, OnboardingDemoDefinition.selector, OnboardingTourDefinition.selector, CemCalloutDefinition.selector]),
  shouldTrackRenderedForChild: () => {
    return true;
  },
  shouldTrackDismissedForChild: () => {
    return true;
  },
  getNudgeProperties: ({
    element
  }) => {
    var _headerElement$nextEl;
    const headerElement = element.querySelector(`header`);
    const title = isHTMLElement(headerElement) ? getTranslationOrInnerText(headerElement) : 'no-title';
    const bodyElement = headerElement === null || headerElement === void 0 || (_headerElement$nextEl = headerElement.nextElementSibling) === null || _headerElement$nextEl === void 0 ? void 0 : _headerElement$nextEl.firstElementChild;
    const text = isHTMLElement(bodyElement) ? getTranslationOrInnerText(bodyElement) : 'no-text';
    const properties = {
      type: NudgeTypes.POPOVER,
      text,
      title
    };
    return properties;
  }
};